import {
  apiRequest,
  listEmployeeTunsus,
  detailPeriodTunsus,
  addEmployee,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      addEmployee,
      {
        body: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      listEmployeeTunsus,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      detailPeriodTunsus,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
